import { MaxWidth } from "shared/components/MaxWidth";
import {
  SMALL,
  TYPE_RICHTEXT_SIMPLE,
  TYPE_RICHTEXT_SANS,
} from "shared/utils/constants";
import styles from "./RichText.module.css";
import cx from "classnames";

export const RichTextContainer = ({ children, size = SMALL, type }) => (
  <div className="RichTextContainer">
    <MaxWidth size={size}>
      <RichText type={type}>{children}</RichText>
    </MaxWidth>
  </div>
);

export const RichText = ({ children, type }) => (
  <div
    className={cx(styles.container, {
      [styles.smallSans]: type === TYPE_RICHTEXT_SIMPLE,
      [styles.sans]: type === TYPE_RICHTEXT_SANS,
    })}
  >
    {children}
  </div>
);
